import image from "./complete.svg";
import { FormattedMessage } from "react-intl";
import { CONTENT, MISC_INFO } from "../../../../reduxStore/actions/main";
import {
  BottomButton,
  BottomButtonContainer,
} from "../../../elements/wrapper/bottomButton.wrapper.jsx";
import IntroImage from "../../introImage.component.jsx";
import { pageNames } from "../../../../reduxStore/reducers/main.js";
import StandardHeadline from "../../../elements/text/standardHeadline.text.jsx";
import { statisticLogger } from "../../../statisticLogger/StatisticLogger.container";

export default function Complete(props) {
  const handleClick = () => {
    props.completeIntro();
    statisticLogger.addLog({
      action: {
        id: "introCompleteClick",
        name: "introComplete",
        type: "click",
        group: "Intro",
      },
    });
    const globalParams = new URLSearchParams(window.location.search);
    const page = globalParams.get("page");
    globalParams.delete("page");
    const noPage = page === "" || page == null;

    const start = globalParams.get("start");
    const destination = globalParams.get("destination");

    const fallbackpage =
      start || destination ? "map" : MISC_INFO.tabBarOrder?.[0];

    switch (noPage ? fallbackpage : page) {
      // WICHTIG ZU WISSEN: wenn ein "/" ganz am anfang der url ist, dann wird diese ERSETZT
      // ist kein "/" am anfang der URL, wird diese auf die momentane GEPUSHT!
      case "events":
        props.history.push(`/${pageNames.events}${window.location.search}`);
        break;
      case "news":
        props.history.push(`/${pageNames.news}${window.location.search}`);
        break;
      default:
        props.history.push(
          `/${pageNames.map}/${pageNames.info}${window.location.search}`
        );
    }
  };

  const lang =
    props.language === "de"
      ? "de_DE"
      : props.language === "en"
      ? "en_EN"
      : props.language === "fr"
      ? "fr_FR"
      : props.language;

  const introText = MISC_INFO?.introText?.[lang];

  return (
    <BottomButtonContainer
      buttons={[
        new BottomButton(
          handleClick,
          <FormattedMessage id="welcome.finish" />,
          {
            disabled: !CONTENT.length,
            loading: true,
            className: "normalButton--primary",
          }
        ),
      ]}
    >
      <IntroImage imageName={"complete.svg"} fallbackImage={image} />
      <div className=" general-padding-large-horizontally">
        <StandardHeadline className={"mb-2 mt-3"} type={"h2"}>
          <FormattedMessage id="welcome.completeTitle" />
        </StandardHeadline>
        {introText ? (
          <div
            className="standardInstruction mb-4"
            dangerouslySetInnerHTML={{ __html: introText }}
          />
        ) : null}
      </div>
    </BottomButtonContainer>
  );
}
